module.exports = __webpack_public_path__ + "static/media/LK.18037e9b.png";